import { render } from "./ClaimHistoricalChanges.vue?vue&type=template&id=3a70f21e"
import script from "./ClaimHistoricalChanges.vue?vue&type=script&lang=js"
export * from "./ClaimHistoricalChanges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__